module.exports = __webpack_public_path__ + "img/z02.682bd40f.jpg";